import {AbstractModel} from '../abstract-model';
import {PartnerTypeStat} from './partner-type-stat';

export class PartnerTypesStat extends AbstractModel {
  today: PartnerTypeStat = new PartnerTypeStat();
  yesterday: PartnerTypeStat = new PartnerTypeStat();
  thisMonth: PartnerTypeStat = new PartnerTypeStat();
  lastMonth: PartnerTypeStat = new PartnerTypeStat();

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.today) {
      this.today = new PartnerTypeStat().deserialize(input.today);
    }

    if (input.yesterday) {
      this.yesterday = new PartnerTypeStat().deserialize(input.yesterday);
    }

    if (input['this-month']) {
      this.thisMonth = new PartnerTypeStat().deserialize(input['this-month']);
    }

    if (input['last-month']) {
      this.lastMonth = new PartnerTypeStat().deserialize(input['last-month']);
    }

    return this;
  }
}
